import { render } from "./PureBiddingDetails.vue?vue&type=template&id=6530a27a&scoped=true"
import script from "./PureBiddingDetails.vue?vue&type=script&lang=js"
export * from "./PureBiddingDetails.vue?vue&type=script&lang=js"

import "./PureBiddingDetails.vue?vue&type=style&index=0&id=6530a27a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6530a27a"]])

export default __exports__